import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SocialEmbedInsertModal from './SocialEmbedInsertModal.js';
import 'wix-rich-content-ui-components';
import '../defaults.js';
import '../types.js';
import 'wix-rich-content-common';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class EmbedURLInputModal extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "onConfirm", (data) => {
      const { pubsub, onConfirm } = this.props;
      if (onConfirm) {
        onConfirm(data);
      } else {
        pubsub.update("componentData", data);
      }
    });
  }
  render() {
    const { t, languageDir, socialType, helpers, isMobile, experiments, componentData, fetchData } = this.props;
    return /* @__PURE__ */ React.createElement(
      SocialEmbedInsertModal,
      {
        onConfirm: this.onConfirm,
        helpers,
        componentData,
        t,
        languageDir,
        closeModal: helpers == null ? void 0 : helpers.closeModal,
        isMobile,
        socialType,
        experiments,
        fetchData
      }
    );
  }
}
EmbedURLInputModal.propTypes = {
  onConfirm: PropTypes.func,
  pubsub: PropTypes.object,
  helpers: PropTypes.object.isRequired,
  componentData: PropTypes.object.isRequired,
  t: PropTypes.func,
  languageDir: PropTypes.string,
  fetchData: PropTypes.func,
  socialType: PropTypes.string,
  isMobile: PropTypes.bool,
  experiments: PropTypes.object
};

export { EmbedURLInputModal as default };
//# sourceMappingURL=embedURLInputModal.js.map
